import script from "./LandingTestimonial.vue?vue&type=script&setup=true&lang=js"
export * from "./LandingTestimonial.vue?vue&type=script&setup=true&lang=js"

import "./LandingTestimonial.vue?vue&type=style&index=0&id=7824e7ab&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7824e7ab"]])

export default __exports__